import type { ParentComponent } from "solid-js";
import { createEffect } from "solid-js";
import type { LoginStatus } from "./state/auth";
import { useAuthState } from "./state/auth";
import { QueryClient, QueryClientProvider as Provider } from "@tanstack/solid-query";
import type { MoreAppError } from "./MoreAppError";
import { DEFAULT_MAX_RETRIES } from "./utils/apiUtil";

declare module "@tanstack/solid-query" {
  /* oxlint-disable @typescript-eslint/consistent-type-definitions */
  interface Register {
    defaultError: MoreAppError;
  }
}

const QueryClientProvider: ParentComponent = (props) => {
  const { loginStatus } = useAuthState();
  const client = new QueryClient({
    defaultOptions: {
      queries: {
        retry: DEFAULT_MAX_RETRIES,
      },
    },
  });

  let previousLoginStatus: LoginStatus | undefined;
  createEffect(() => {
    const status = loginStatus();
    if (status === "loggedOut" && previousLoginStatus === "loggedIn") {
      client.clear();
    }
    previousLoginStatus = status;
  });

  return <Provider client={client}>{props.children}</Provider>;
};

export default QueryClientProvider;
